import * as THREE from 'three';

export class Road {
  static createMainRoad(width: number, length: number): THREE.Mesh {
    const geometry = new THREE.PlaneGeometry(width, length);
    const material = new THREE.MeshPhongMaterial({
      color: 0x404040,
      side: THREE.DoubleSide
    });
    const road = new THREE.Mesh(geometry, material);
    // Make sure rotation is only applied once here
    road.rotation.x = -Math.PI / 2;
    return road;
  }

  static createSidewalk(width: number, height: number, length: number): THREE.Mesh {
    return new THREE.Mesh(
      new THREE.BoxGeometry(width, height, length),
      new THREE.MeshPhongMaterial({ color: 0x808080 })
    );
  }

  static createFinishLine(width: number): THREE.Mesh {
    return new THREE.Mesh(
      new THREE.PlaneGeometry(width, 1),
      new THREE.MeshPhongMaterial({ 
        color: 0xffffff,
        side: THREE.DoubleSide,
        transparent: true,
        opacity: 0.8
      })
    );
  }
}